'use client'

import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { EVENTS } from '@configs/events.config'
import { TENANT_TYPE } from '@components/Ackodrive/common/constants'
import { useAnimateOnVisible } from '@hooks/useAnimateOnVisible'
import { arrowUrl, BrandHubCardProps, hoverArrowUrl } from '@components/BrandHub/BrandHubMock'
import styles from './BrandHubCard.module.scss'

const BrandHubCard: React.FC<{ data: BrandHubCardProps }> = ({ data }) => {
  const { ref, animationClassName } = useAnimateOnVisible<HTMLAnchorElement>({ threshold: 0.1 })
  const handleClick = async (url: string) => {
    await trackEvent(EVENTS[TENANT_TYPE.BRANDHUB].engage.eventname, {
      ...EVENTS[TENANT_TYPE.BRANDHUB].engage.eventProps,
      journey: data.cardName.toLowerCase(),
      redirection_url: url,
    })
  }
  return (
    <Link
      ref={ref}
      href={data.url}
      target="_blank"
      onClick={() => {
        void handleClick(data.url)
      }}
      className={`${styles.brandHubCard} ${animationClassName}`}
      style={{
        backgroundImage: `url(${data.bgImgUrl})`,
      }}>
      <div className={styles.brandHubContent}>
        <p className={styles.brandHubTitle}>{data.cardName}</p>
        <p className={styles.brandHubDescription}>{data.cardDescription}</p>
      </div>
      <div className={styles.arrow}>
        <Image src={arrowUrl} alt="right arrow" height={46} width={46} />
        <Image src={hoverArrowUrl} alt="right arrow" height={46} width={46} />
      </div>
    </Link>
  )
}

export default BrandHubCard
